import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
  ARTICLE_LIST,
  ARTICLE_SEARCH_ARTICLE_GROUP_LIST,
  ARTICLE_DETAIL,
  ARTICLE_SEARCH_PROJECT_LIST,
  ARTICLE_SEARCH_YEAR_LIST,
  ARTICLE_SEARCH_ARTICLE_TYPE_LIST,
  ARTICLE_SEARCH_DEMAND_LIST
} from '../actions';
import {
  ArticleListSuccess,
  ArticleListError,
  ArticleSearchArticleGroupListSuccess,
  ArticleSearchArticleGroupListError,
  ArticleSearchProjectListSuccess,
  ArticleSearchProjectListError,
  ArticleSearchYearListSuccess,
  ArticleSearchYearListError,
  ArticleDetailSuccess,
  ArticleDetailError,
  ArticleSearchArticleTypeListSuccess,
  ArticleSearchArticleTypeListError,
  ArticleSearchDemandListSuccess,
  ArticleSearchDemandListError
} from '../actions';

export function* watchArticleList() {
  yield takeEvery(ARTICLE_LIST, onArticleList);
}

export function* watchArticleSearchArticleGroupList() {
  yield takeEvery(ARTICLE_SEARCH_ARTICLE_GROUP_LIST, onArticleSearchArticleGroupList);
}

export function* watchArticleDetail() {
  yield takeEvery(ARTICLE_DETAIL, onArticleDetail);
}

export function* watchArticleSearchProjectList() {
  yield takeEvery(ARTICLE_SEARCH_PROJECT_LIST, onArticleSearchProjectList);
}

export function* watchArticleSearchYearList() {
  yield takeEvery(ARTICLE_SEARCH_YEAR_LIST, onArticleSearchYearList);
}

export function* watchArticleSearchArticleTypeList() {
  yield takeEvery(ARTICLE_SEARCH_ARTICLE_TYPE_LIST, onArticleSearchArticleTypeList);
}

export function* watchArticleSearchDemandList() {
  yield takeEvery(ARTICLE_SEARCH_DEMAND_LIST, onArticleSearchDemandList);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onArticleListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'article/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onArticleSearchArticleGroupListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/article_group', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onArticleDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'article/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onArticleSearchProjectListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/project', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onArticleSearchYearListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/year', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onArticleSearchArticleTypeListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/article_type', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onArticleSearchDemandListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/demand', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

function* onArticleList(data) {
  try {
    const response = yield call(onArticleListAsync, data.payload);
    yield put(ArticleListSuccess(response.data));
  } catch (error) {
    yield put(ArticleListError(error));
  }
}

function* onArticleDetail(data) {
  try {
    const response = yield call(onArticleDetailAsync, data.payload);
    yield put(ArticleDetailSuccess(response.data.data));
  } catch (error) {
    yield put(ArticleDetailError(error));
  }
}


function* onArticleSearchArticleGroupList(data) {
  try {
    const response = yield call(onArticleSearchArticleGroupListAsync, data);
    yield put(ArticleSearchArticleGroupListSuccess(response.data));
  } catch (error) {
    yield put(ArticleSearchArticleGroupListError(error));
  }
}

function* onArticleSearchProjectList(data) {
  try {
    const response = yield call(onArticleSearchProjectListAsync, data);
    yield put(ArticleSearchProjectListSuccess(response.data));
  } catch (error) {
    yield put(ArticleSearchProjectListError(error));
  }
}

function* onArticleSearchYearList(data) {
  try {
    const response = yield call(onArticleSearchYearListAsync, data);
    yield put(ArticleSearchYearListSuccess(response.data));
  } catch (error) {
    yield put(ArticleSearchYearListError(error));
  }
}

function* onArticleSearchArticleTypeList(data) {
  try {
    const response = yield call(onArticleSearchArticleTypeListAsync, data);
    yield put(ArticleSearchArticleTypeListSuccess(response.data));
  } catch (error) {
    yield put(ArticleSearchArticleTypeListError(error));
  }
}

function* onArticleSearchDemandList(data) {
  try {
    const response = yield call(onArticleSearchDemandListAsync, data);
    yield put(ArticleSearchDemandListSuccess(response.data));
  } catch (error) {
    yield put(ArticleSearchDemandListError(error));
  }
}
export default function* rootSaga() {
  yield all([
    fork(watchArticleList),
    fork(watchArticleSearchArticleGroupList),
    fork(watchArticleSearchProjectList),
    fork(watchArticleSearchYearList),
    fork(watchArticleDetail),
    fork(watchArticleSearchArticleTypeList),
    fork(watchArticleSearchDemandList)
  ]);
}